"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Popover = (0, _styledComponents["default"])(_slice.Box)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  width: 232px;\n  padding: 8px;\n  margin-top: 12px;\n  border: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);\n"], ["\n  width: 232px;\n  padding: 8px;\n  margin-top: 12px;\n  border: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);\n"])), function (_a) {
  var theme = _a.theme;
  return "1px solid " + theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
exports.Popover = Popover;
var templateObject_1;